import { RewardTypeEnum } from "@/types/reward";
import RefferralIcon from "@/features/reward/assets/refferral.png";
import RankingIcon from "@/features/reward/assets/ranking.png";
import WelcomeIcon from "@/features/reward/assets/welcome.png";
import CalendarIcon from "@/assets/images/vip/vip-reward-calendar-icon.png";
import TurntableIcon from "@/features/reward/assets/icon_liebianzhuanpan.png";
import RechargeWellIcon from "@/features/reward/assets/recharge-well.png";
import BonusIcon from "@/features/reward/assets/bonus.png";
import VipIcon from "@/features/reward/assets/vip.png";
import VipDayIcon from "@/assets/images/vip/vip-day-icon.png";
import VipWeekIcon from "@/assets/images/vip/vip-week-icon.png";
import VipMonthIcon from "@/assets/images/vip/vip-month-icon.png";
import VipUpgradeIcon from "@/assets/images/vip/vip-upgrade-icon.png";
import VipCashbackIcon from "@/features/reward/assets/vip-cashback.png";

export const IconMap: Record<RewardTypeEnum, string> = {
  [RewardTypeEnum.WELCOME_GIFT]: WelcomeIcon.src,
  [RewardTypeEnum.CALENDAR_REWARD]: CalendarIcon.src,
  [RewardTypeEnum.PROMOTION_REWARD]: VipUpgradeIcon.src,
  [RewardTypeEnum.CASH_BACK]: VipCashbackIcon.src,
  [RewardTypeEnum.WEEKLY_REWARD]: VipWeekIcon.src,
  [RewardTypeEnum.MONTHLY_REWARD]: VipMonthIcon.src,
  [RewardTypeEnum.DAILY_REWARD]: VipDayIcon.src,
  [RewardTypeEnum.TRIGGER_REWARD]: VipIcon.src,
  [RewardTypeEnum.CUMULATIVE_REWARD]: RechargeWellIcon.src,
  [RewardTypeEnum.REWARD_UNLOCK]: BonusIcon.src,
  [RewardTypeEnum.INVITE_REWARD]: RefferralIcon.src,
  [RewardTypeEnum.RANKING_REWARD]: RankingIcon.src,
  [RewardTypeEnum.TURNTABLE_REWARD]: TurntableIcon.src,
};